import { Icon } from '@iconify/react/dist/iconify.js';
import React from 'react';
import useReactApexChart from '../../hook/useReactApexChart';
import ReactApexChart from 'react-apexcharts';

const SalesReport = ({ dashboardData }) => {
    // let { paymentStatusChartSeriesThree, paymentStatusChartOptionsThree } = useReactApexChart();

    const salesReportData = dashboardData?.[0]
    console.log("Sales Report Page", salesReportData)

    const payment_history = salesReportData?.payment_history?.[0]

    let paymentStatusChartSeriesThree = [
        {
            name: "Revenue",
            data: Array.isArray(payment_history?.data) && payment_history.data.length === 12
                ? payment_history.data
                : Array(12).fill(0), // fallback if data is missing or incorrect length
        },
    ];


    let paymentStatusChartOptionsThree = {
      colors: ["#243E85"],
      labels: ["Active", "New", "Total"],
      legend: {
        show: false,
      },
      chart: {
        type: "bar",
        height: 250,
        toolbar: {
          show: false,
        },
      },
      grid: {
        show: true,
        borderColor: "#D1D5DB",
        strokeDashArray: 4,
        position: "back",
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          columnWidth: 10,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        labels: {
          style: {
            fontSize: "12px",
          },
        },
      },
      yaxis: {
        labels: {
          formatter: function (val) {
            if (val >= 1000) {
              return val / 1000 + "K";
            }
            return val;
          },
          style: {
            fontSize: "12px",
          },
        },
      },
      fill: {
        opacity: 1,
      },
    };

    const formatShortCurrency = (num) => {
        if (!num) return "$0";
        const absNum = Math.abs(num);
        const sign = num < 0 ? "-" : "";

        if (absNum >= 1_000_000_000) {
            return `${sign}$${(absNum / 1_000_000_000).toFixed(1)}B`;
        } else if (absNum >= 1_000_000) {
            return `${sign}$${(absNum / 1_000_000).toFixed(1)}M`;
        } else if (absNum >= 1_000) {
            return `${sign}$${(absNum / 1_000).toFixed(1)}K`;
        } else {
            return `${sign}$${absNum.toFixed(2)}`;
        }
    };

    const formatShortNumber = (num) => {
        if (!num) return "0";
        const abs = Math.abs(num);
        if (abs >= 1_000_000_000) return (abs / 1_000_000_000).toFixed(1) + "B";
        if (abs >= 1_000_000) return (abs / 1_000_000).toFixed(1) + "M";
        if (abs >= 1_000) return (abs / 1_000).toFixed(1) + "K";
        return abs.toString();
    };

    const formatShortWeight = (num) => {
        if (!num) return "0 KG";
        const abs = Math.abs(num);
        if (abs >= 1_000_000) return (abs / 1_000_000).toFixed(1) + "M KG";
        if (abs >= 1_000) return (abs / 1_000).toFixed(1) + "K KG";
        return num.toFixed(2) + " KG";
    };



    return (
        <div className="col-xxl-9">
            <div className="card radius-8 border-0">
                <div className="row">
                    <div className="col-xxl-6 pe-xxl-0">
                        <div className="card-body p-24">
                            <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
                                <h6 className="mb-2 fw-bold text-lg">Revenue Report</h6>
                                {/* <div className="">
                                    <select className="form-select form-select-sm w-auto bg-base border text-secondary-light" defaultValue="Yearly">
                                        <option value="Yearly">Yearly</option>
                                        <option value="Monthly">Monthly</option>
                                        <option value="Weekly">Weekly</option>
                             
                                    </select>
                                </div> */}
                            </div>
                            <ul className="d-flex flex-wrap align-items-center mt-3 gap-3">
                                {/* <li className="d-flex align-items-center gap-2">
                                    <span className="w-12-px h-12-px radius-2 bg-primary-600" />
                                    <span className="text-secondary-light text-sm fw-semibold">
                                        Earning:
                                        <span className="text-primary-light fw-bold">
                                            $500,00,000.00
                                        </span>
                                    </span>
                                </li> */}
                                {/* <li className="d-flex align-items-center gap-2">
                                    <span className="w-12-px h-12-px radius-2 bg-yellow" />
                                    <span className="text-secondary-light text-sm fw-semibold">
                                        Expense:
                                        <span className="text-primary-light fw-bold">$20,000.00</span>
                                    </span>
                                </li> */}
                            </ul>
                            <div className="mt-40">
                                <ReactApexChart options={paymentStatusChartOptionsThree} series={paymentStatusChartSeriesThree} type="bar" height={250} id="paymentStatusChart" className="margin-16-minus" />
                            </div>
                        </div>
                    </div>
                    <div className="col-xxl-6">
                        <div className="row h-100 g-0">


                            <div className="col-6 p-0 m-0">
                                <div className="card-body p-24 h-100 d-flex flex-column justify-content-center border border-top-0">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                        <div>
                                            <span className="mb-12 w-44-px h-44-px text-primary-600 bg-primary-light border border-primary-light-white flex-shrink-0 d-flex justify-content-center align-items-center radius-8 h6 mb-12">


                                                <Icon
                                                    icon="ri:discount-percent-fill"
                                                    className="icon"
                                                />
                                            </span>
                                            <span className="mb-1 fw-medium text-secondary-light text-md">
                                                {dashboardData?.[0]?.title || "Total Revenue"}
                                            </span>
                                            <h6 className="fw-semibold text-primary-light mb-1">     {formatShortCurrency(salesReportData?.totalRevenue)} </h6>
                                        </div>
                                    </div>
                                    {/* <p className="text-sm mb-0">
                                        Increase by{" "}
                                        <span className="bg-success-focus px-1 rounded-2 fw-medium text-success-main text-sm">
                                            +200
                                        </span>{" "}
                                        this week
                                    </p> */}
                                </div>
                            </div>
                            <div className="col-6 p-0 m-0">
                                <div className="card-body p-24 h-100 d-flex flex-column justify-content-center border border-top-0 border-start-0 border-end-0">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                        <div>
                                            <span className="mb-12 w-44-px h-44-px text-yellow bg-yellow-light border border-yellow-light-white flex-shrink-0 d-flex justify-content-center align-items-center radius-8 h6 mb-12">
                                                <Icon
                                                    icon="flowbite:users-group-solid"
                                                    className="icon"
                                                />
                                            </span>
                                            <span className="mb-1 fw-medium text-secondary-light text-md">
                                                {dashboardData?.[1]?.title || "Total Users"}
                                            </span>
                                            <h6 className="fw-semibold text-primary-light mb-1">
                                                {formatShortNumber(salesReportData?.total_users)}
                                            </h6>
                                        </div>
                                    </div>
                                    {/* <p className="text-sm mb-0">
                                        Increase by{" "}
                                        <span className="bg-danger-focus px-1 rounded-2 fw-medium text-danger-main text-sm">
                                            -5k
                                        </span>{" "}
                                        this week
                                    </p> */}
                                </div>
                            </div>
                            <div className="col-6 p-0 m-0">
                                <div className="card-body p-24 h-100 d-flex flex-column justify-content-center border border-top-0 border-bottom-0">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                        <div>
                                            <span className="mb-12 w-44-px h-44-px text-lilac bg-lilac-light border border-lilac-light-white flex-shrink-0 d-flex justify-content-center align-items-center radius-8 h6 mb-12">
                                                {/* <Icon
                                                    icon="majesticons:shopping-cart"
                                                    className="icon"
                                                /> */}

                                                <Icon icon="fa-solid:box-open" className="icon" />
                                            </span>
                                            <span className="mb-1 fw-medium text-secondary-light text-md">
                                                {dashboardData?.[2]?.title || "Total Order Weight"}
                                            </span>
                                            <h6 className="fw-semibold text-primary-light mb-1">
                                                {formatShortWeight(salesReportData?.total_order_weight || 0)}
                                            </h6>
                                        </div>
                                    </div>
                                    {/* <p className="text-sm mb-0">
                                        Increase by{" "}
                                        <span className="bg-success-focus px-1 rounded-2 fw-medium text-success-main text-sm">
                                            +1k
                                        </span>{" "}
                                        this week
                                    </p> */}
                                </div>
                            </div>
                            <div className="col-6 p-0 m-0">
                                <div className="card-body p-24 h-100 d-flex flex-column justify-content-center border border-top-0 border-start-0 border-end-0 border-bottom-0">
                                    <div className="d-flex flex-wrap align-items-center justify-content-between gap-1 mb-8">
                                        <div>
                                            <span className="mb-12 w-44-px h-44-px text-pink bg-pink-light border border-pink-light-white flex-shrink-0 d-flex justify-content-center align-items-center radius-8 h6 mb-12">
                                                <Icon
                                                    icon="majesticons:shopping-cart"
                                                    className="icon"
                                                />
                                            </span>
                                            <span className="mb-1 fw-medium text-secondary-light text-md">
                                                {dashboardData?.[3]?.title || "Total Orders"}
                                            </span>
                                            <h6 className="fw-semibold text-primary-light mb-1">
                                                {formatShortNumber(salesReportData?.total_orders)}
                                            </h6>
                                        </div>
                                    </div>
                                    {/* <p className="text-sm mb-0">
                                        Increase by{" "}
                                        <span className="bg-success-focus px-1 rounded-2 fw-medium text-success-main text-sm">
                                            +$10k
                                        </span>{" "}
                                        this week
                                    </p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SalesReport;